export function HomePage() {
  return (
    <div className="flex h-full items-center justify-center p-12">
      <div className="text-center">
        <img src="/logo.png" alt="StarFox" className="mx-auto mb-6 h-24 w-24 rounded-full shadow-m3" />
        <h1 className="text-4xl font-semibold tracking-tight">
          欢迎来到 <span className="text-brand-500">StarFox</span>
        </h1>
        <p className="mt-3 text-neutral-600">
          让每一个有故事的人,都能在 72 小时内把脑海里的画面变成可发行的短剧。
        </p>
      </div>
    </div>
  );
}
